import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";

const TableCell = ({ field, building, handleIdClick, width, fetchedData }) => {
  let displayValue = building[field.key];

  // trim whitespace from displayValue
  if (typeof displayValue === "string") {
    displayValue = displayValue.trim();
  }

  if (field.type === "date") {
    const date = new Date(displayValue);
    displayValue = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  if (displayValue === null || displayValue === "") {
    return <td className="px-4 py-1">-</td>;
  }

  const finalDisplay = String(displayValue) ?? "-";

  const contentStyle = {
    display: "inline-block",
    width: width,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const content = <span style={contentStyle}>{finalDisplay}</span>;

  if (field.key === "buildingReference") {
    return (
      <td
        className="px-4 py-1 cursor-pointer text-sss-info"
        onClick={(e) => {
          e.stopPropagation();
          if (handleIdClick) {
            handleIdClick(building);
          }
        }}
      >
        <Tooltip
          title={`Open Building ${building[field.key]}`}
          enterDelay={1000}
        >
          {content}
        </Tooltip>
      </td>
    );
  }

  if (field.key === "agencyID") {
    // Convert both values to string to ensure a consistent comparison
    const agency = fetchedData?.agencies.find(
      (agency) => String(agency?.agencyId) === String(displayValue)
    );
    const agencyName = agency ? agency?.agencyName : "Unknown Agency";
    return (
      <td className="px-4 py-1" key={`${field.key}-${building.buildingID}`}>
        <Tooltip title={agencyName}>{agencyName}</Tooltip>
      </td>
    );
  }

  if (field.key === "customerID") {
    const customer = fetchedData?.customers.find(
      (customer) => String(customer?.customerID) === String(displayValue)
    );
    const customerName = customer ? customer?.customerName : "Unknown Customer";
    return (
      <td className="px-4 py-1" key={`${field.key}-${building.buildingID}`}>
        <Tooltip title={customerName}>{customerName}</Tooltip>
      </td>
    );
  }

  if (field.key === "managementID") {
    // Use building's customerID to find the customer first.
    const customer = fetchedData?.customers.find(
      (customer) =>
        String(customer?.customerID) === String(building?.customerID)
    );
    let managementCompanyName = "-";
    if (customer && customer?.managementID) {
      // Convert both values to string for a consistent comparison
      const managementCompany = fetchedData?.managementCompanies.find(
        (company) =>
          String(company?.managementId) === String(customer.managementID)
      );
      managementCompanyName = managementCompany
        ? managementCompany?.companyName
        : "Unknown Management Company";
    }
    return (
      <td className="px-4 py-1" key={`${field.key}-${building.buildingID}`}>
        <Tooltip title={managementCompanyName}>{managementCompanyName}</Tooltip>
      </td>
    );
  }

  return (
    <td className="px-4 py-1" key={`${field.key}-${building.buildingID}`}>
      <Tooltip title={finalDisplay}>{content}</Tooltip>
    </td>
  );
};

TableCell.propTypes = {
  field: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  handleIdClick: PropTypes.func,
  width: PropTypes.number.isRequired,
};

export default TableCell;
